import { useLiveQuery } from "dexie-react-hooks";
import { db } from "~db/db";
import formatDate from "~services/utils/formatDate";

const useUltimaVisitaMap = (clienteIds = []) => {
  const ids = Array.isArray(clienteIds) ? clienteIds.filter(Boolean) : [];

  const map = useLiveQuery(async () => {
    if (!ids.length) return {};

    const rows = await db.ultimaVisita.where('id').anyOf(ids).toArray();

    return rows.reduce((acc, row) => {
      if (row?.id && row?.data) {
        acc[row.id] = formatDate(new Date(row.data));
      }
      return acc;
    }, {});
  }, [ids.join(',')]);

  return map || {};
};

export default useUltimaVisitaMap;
